import { Components } from 'react-markdown';
import { Heading1, Heading2 } from '../components/headings';
import { UnsafeExternalLink } from '../components/shared/UnsafeExternalLink';
import { NavLink } from 'react-router';

const components: Partial<Components> = {
    h1({ children }) {
        return <Heading1 children={children} />;
    },
    h2({ children }) {
        return <Heading2 children={children} />;
    },
    ul({ children }) {
        return <ul children={children} className='list-outside list-disc my-4 ps-6' />;
    },
    ol({ children }) {
        return <ol children={children} className='list-outside list-decimal my-4 ps-6 space-y-4' />;
    },
    a({ children, className: _className, node: _node, href }) {
        if (href === undefined) return;
        try {
            const url = new URL(href.startsWith('http') ? href : window.location.origin + href);
            if (url.hostname === 'gdladder.com' || url.hostname === 'localhost')
                return (
                    <NavLink to={url.pathname} className='link'>
                        {children}
                    </NavLink>
                );
            return <UnsafeExternalLink to={url.toString()}>{children}</UnsafeExternalLink>;
        } catch {
            return null;
        }
    },
    img() {
        return <p>{'[Image]'}</p>;
    },
    p({ children }) {
        return <p className='mb-4 whitespace-pre-line last:mb-0'>{children}</p>;
    },
};

export default components;
